import React, { useEffect } from 'react'
import { Box, Grid, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStoreActions, useStoreState } from '../../store/store.hooks'
//import { useForm } from 'react-hook-form'
import { Heading } from '@/components/Text'
import ProfessionalMeetingList from './ProfessionalMeetingList'
import { NavigateBack } from '@/components/Nav/NavigateBack'

const useStyles = makeStyles((theme) => ({
  meetingsContainer: {
    padding: '2rem',

    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '15px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
}))

const ProfessionalMeetings = (
  {
    /* props */
  }
) => {
  const classes = useStyles()
  const {
    i18n: { language },
    t,
  } = useTranslation('professionalMeetings')
  const { fetchMeetings } = useStoreActions((action) => action.professional)
  const { meetings } = useStoreState((state) => state.professional)

  useEffect(() => {
    fetchMeetings({ language })
  }, [fetchMeetings])

  return (
    <>
      <Grid container item xs={12} className={classes.meetingsContainer}>
        <NavigateBack />
        <Heading>{t('heading')}</Heading>

        <ProfessionalMeetingList meetings={meetings} />
      </Grid>
    </>
  )
}

ProfessionalMeetings.displayName = 'ProfessionalMeetings'
export { ProfessionalMeetings }
export default ProfessionalMeetings
